<template>
  <div v-if="mobConfig.showPriceWithoutDPH">
    <p
      v-if="price.priceWithoutVat != price.priceWithoutVatBeforeDiscount"
      class="text--primary my-4"
    >
      <del>
        <span class="text--secondary"
          >Původní cena bez DPH:
          {{ price.priceWithoutVatBeforeDiscount / 100 }}
          {{ $t(mobConfig.currency) }}
        </span>
      </del>
    </p>

    <p class="my-4">
      <span class="text-h6 text--secondary">Cena bez DPH: </span><br />
      <span class="text-h4 text--primary">
        {{ price.priceWithoutVat / 100 }}
        {{ $t(mobConfig.currency) }}
      </span>
    </p>

    <p class="my-2">
      <span class="text--secondary">Cena s DPH: </span>
      <span class="text--primary">
        {{ price.priceWithVat / 100 }}
        {{ $t(mobConfig.currency) }}
      </span>
    </p>

    <p v-if="deposit" class="subtitle-1">
      Kauce: {{ deposit / 100 }} {{ $t(mobConfig.currency) }}
    </p>
  </div>

  <div v-else>
    <p
      v-if="
        price.priceWithVatBeforeDiscount &&
        price.priceWithVat != price.priceWithVatBeforeDiscount
      "
      class="text--primary my-4"
    >
      <del>
        Původní cena:
        {{ price.priceWithVatBeforeDiscount / 100 }}
        {{ $t(mobConfig.currency) }}
      </del>
    </p>

    <p class="display-1 text--primary my-4">
      Cena: <br />
      {{ price.priceWithVat / 100 }}
      {{ $t(mobConfig.currency) }}
    </p>

    <p v-if="deposit" class="subtitle-1">
      Kauce: {{ deposit / 100 }} {{ $t(mobConfig.currency) }}
    </p>
  </div>
</template>

<script>
export default {
  name: "PriceSummary",

  props: {
    price: {
      type: Object,
      required: true,
    },

    deposit: {
      type: Number,
      required: false,
    },
  },

  computed: {
    mobConfig() {
      return this.$store.state.mobConfig;
    },
  },
};
</script>
